import type { ICrewMember } from '../../types/api/ICrewMember';
import type { IUnitInfo } from '../../types/api/IUnitInfo';
import type { IVehicleInfo } from '../../types/api/IVehicleInfo';

import { Ref } from '@/decorators/ref';
import { assignOwnProperties } from '@/utils/assignOwnProperties';
import { normalize } from '@/utils/normalize';

export class Unit implements IUnitInfo {
  @Ref unitId: string;
  @Ref name: string;
  @Ref status: string;
  @Ref vehicle: IVehicleInfo;
  @Ref mobileStatus: string;
  @Ref crew: ICrewMember[];
  @Ref sentTime: string;

  constructor(data: Unit) {
    assignOwnProperties(this, normalize(data));
  }
}
